import { v4 as uuidv4 } from 'uuid';
const makeSlotId = (zone) => `ad-${zone != null ? zone + '-' : ''}${uuidv4().replace(/-/g, '')}`;
export default makeSlotId;
//# sourceMappingURL=makeSlotId.js.map